import AttachmentEditor from '@components/AttachmentEditor'
import { Plan } from '@models/membership/Plan'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule } from '@utils/rules'
import { Card, Divider, Flex, Form, Input, Switch, Typography } from 'antd'
import { Localizable } from '../../localizable/Localizable'
const { Text } = Typography
const Create = ({ form, formProps }: SBRMFormActionProps) => {
  return (
    <Form {...formProps} form={form} layout="vertical">
      <Form.Item
        name="name"
        label="Name"
        rules={[requiredRule()]}
        extra={
          "This is only an internal reference. This won't be visible in the app."
        }
      >
        <Input required />
      </Form.Item>
      <Localizable.Input name="title" rules={[requiredRule()]} label="Title" />
      <Localizable.Input
        name="caption"
        label="Caption"
        rules={[requiredRule()]}
      />
      <Localizable.TextArea
        name="description"
        label="Description"
        rules={[requiredRule()]}
      />
      <AttachmentEditor
        label={'Cover'}
        formItem={{ name: 'picture', rules: [requiredRule()] }}
        dragger={{ fileTypes: ['picture'] }}
        image={{ width: 1200, height: 675, aspect: 16 / 9 }}
      />
      <Form.Item label={'Plans'} name="plans" rules={[requiredRule()]}>
        <SBAsyncSelect<Plan>
          entity={Entity.membershipPlan}
          multiple
          allowClear
        />
      </Form.Item>
      <Divider />
      <Flex vertical gap={16}>
        <Card>
          <Flex justify="space-between">
            <Text>Visibility</Text>
            <Form.Item
              name="isVisible"
              layout="horizontal"
              valuePropName="checked"
              initialValue={false}
              noStyle
            >
              <Switch
                checkedChildren={'Published'}
                unCheckedChildren={'Draft'}
              />
            </Form.Item>
          </Flex>
        </Card>
        <Card>
          <Flex justify="space-between">
            <Text>Feature this benefit</Text>
            <Form.Item
              name="isFeatured"
              layout="horizontal"
              valuePropName="checked"
              initialValue={false}
              noStyle
            >
              <Switch checkedChildren={'Yes'} unCheckedChildren={'No'} />
            </Form.Item>
          </Flex>
        </Card>
      </Flex>
    </Form>
  )
}

export default Create
